module.exports = __webpack_public_path__ + "img/logo.ae33f221.png";